import SBOTDPlaceholder from './SBOTDPlaceholder.component';

export default SBOTDPlaceholder;